import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';

import { SokratesSsoScriptService } from '../../../shared/services/sokrates-sso-script.service';

@Component({
  selector: 'sokrates-sso-button',
  template: '<span #container></span>'
})
export class SokratesSsoButtonComponent implements AfterViewInit, OnChanges, OnDestroy {
  @ViewChild('container', { static: true }) container: ElementRef<HTMLElement>;

  @Input() language: 'en' | 'id' = 'en';
  @Input() action: 'signIn' | 'signUp' | 'continue' = 'signIn';
  @Input() mode: 'redirect' | null = 'redirect';
  @Input() tenantUuid: string | null = null;
  @Input() clientUrl: string | null = null;
  @Input() disabled = false;

  @Output() loadingChange = new EventEmitter<boolean>();
  @Output() success = new EventEmitter<any>();
  @Output() error = new EventEmitter<any>();

  private button: any = null;

  constructor(private ssoScript: SokratesSsoScriptService) {
  }

  async ngAfterViewInit(): Promise<void> {
    try {
      this.button = await this.ssoScript.createButton({
        language: this.language,
        action: this.action,
        mode: this.mode ?? undefined,
        tenantUuid: this.tenantUuid,
        clientUrl: this.clientUrl,
        disabled: this.disabled,
        onLoadingChange: (loading: boolean) => this.loadingChange.emit(loading),
        onSuccess: (token: any) => this.success.emit(token),
        onError: (err: any) => this.error.emit(err),
      });

      this.container.nativeElement.appendChild(this.button);
    } catch (err) {
      this.error.emit(err);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['disabled'] && this.button?.sokratesSso?.setDisabled) {
      this.button.sokratesSso.setDisabled(this.disabled);
    }
  }

  ngOnDestroy(): void {
    if (this.button?.sokratesSso?.destroy) {
      this.button.sokratesSso.destroy(true);
    }
  }
}
